
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 新增编辑
export function updateSupplier (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/supplier',
    method: 'POST',
    data: parameter
  })
}
// 删除
export function deleteSupplier (ids) {
  return axios({
    url: sysInfo.apiRemote + '/proprietor?ids=' + ids,
    method: 'DELETE'
  })
}
// 供应商列表
export function getSupplierList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/suppliers',
    method: 'GET',
    params: parameter
  })
}
export function getSupplierContacts (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/suppliers/contacts',
    method: 'GET',
    params: parameter
  })
}
// 修改供应商状态
export function editSupplierStatus (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/supplier',
    method: 'PUT',
    data: parameter
  })
}
